import { GetServerSidePropsContext } from 'next'
import { AxiosRequestHeaders } from '@smuchile/pkg-unimarc-hooks'

export const getHeaderCookies = (
  context: GetServerSidePropsContext
): AxiosRequestHeaders => {
  let headers = {}
  const cookies = context?.req?.cookies
  if (cookies?.co_sc) {
    if (!cookies?.co_sc) cookies.co_sc = '39'

    headers = {
      Cookie: `co_sc=${cookies?.co_sc?.toString()}`
    }
  }
  return headers
}
